import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { thousandSeparator } from '../../utils/Utils'
import { Rub } from '../app-icon/Icons'

// Import React Table
import ReactTable from 'react-table'
import 'react-table/react-table.css'

const styles = theme => ({
  tableWrapper: {
    maxWidth: '990px',
    margin: '5px auto 20px auto',
    borderRadius: '8px',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
    overflow: 'hidden',
    paddingBottom: 16,
  },
  tableTitle: {
    fontSize: '14px',
    textAlign: 'center',
    padding: '15px 0',
  },
  tariffsTable: {
    backgroundColor: '#fff',
    '& .ReactTable .rt-thead .rt-th': {
      justifyContent: 'flex-start',
      padding: '9px 0',
    },
    '& .ReactTable .rt-table': {
      overflow: 'auto',
    },
    '& .ReactTable .rt-tbody .rt-td': {
      justifyContent: 'flex-start',
      padding: '10px 16px 10px 16px',
      borderRight: '1px solid rgba(0,0,0,0.03)',
    },
    '& .ReactTable .rt-thead .rt-th div': {
      textAlign: 'left',
      padding: '0 16px',
    },
  },
  paymentError: {
    color: '#ff4e44',
  },
  paymentSuccess: {
    color: 'rgb(95, 71, 178)',
  },
})

class PaymentTariffsTable extends Component {
  state = {
    data: window.state.tariff,
  }

  render() {
    const { classes } = this.props
    const { data } = this.state

    return (
      <div className={classes.tariffsTable}>
        <ReactTable
          data={data}
          pageSize={data.length}
          showPagination={false}
          sortable={false}
          columns={[
            {
              Header: 'Количество\nсеансов',
              accessor: 'sessions',
            },
            {
              Header: `Стоимость лицензии\nна один календарный месяц`,
              id: 'cost',
              accessor: d => Number(d.cost).toFixed(2),
              Cell: ({ value }) => {
                return (
                  <div>
                    {thousandSeparator(Number(value).toFixed(2))}{' '}
                    <Rub width={8} height={8} />
                  </div>
                )
              },
            },
          ]}
          className="-striped -highlight"
        />
      </div>
    )
  }
}

export default withStyles(styles)(PaymentTariffsTable)
